import React, { useState } from "react";
import {
  Box,
  IconButton,
  Typography,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Autocomplete,
  TextField,
  Checkbox,
  ListItemText,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import styles from "./filter.module.css";
const StyledGrid = styled(Grid)(({ theme }) => ({
  // margin: "0 auto",
  marginTop: "1.4rem",
  width: "100%",
  maxWidth: "100%!important",
  textAlign: "center",
  // padding: "0.5rem",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  borderRadius: "8px",
  backgroundColor: "#a39e9e",
}));

const Item = styled("span")(({ theme }) => ({
  display: "inline-block",
  margin: "0.5rem",
  padding: "3px 15px",
  borderRadius: "4px",
  backgroundColor: "#3a6394",
  color: "white",
  fontSize: "1rem",
}));

const DrawerContainer = styled(Box)(({ theme }) => ({
  position: "fixed",
  top: 0,
  right: 0,
  height: "100%",
  width: "30%",
  backgroundColor: theme.palette.background.paper,
  boxShadow: "0 0 10px rgba(0,0,0,0.2)",
  transform: "translateX(100%)",
  transition: "transform 0.3s ease-in-out",
  zIndex: 1300, // Ensure the drawer is on top of other content
}));

const DrawerOpen = styled(DrawerContainer)(({ open }) => ({
  transform: open ? "translateX(0)" : "translateX(100%)",
}));

const Filter = ({ open, onClose, headers, setHeaders }) => {
  // Example options for Autocomplete components
  const softwareVersions = ["1.0.0", "1.1.0", "1.2.0"];
  const cans = ["Can A", "Can B", "Can C"];
  const l89s = ["L89-1", "L89-2", "L89-3"];

  // State for managing selected values
  const [selectedSoftwareVersion, setSelectedSoftwareVersion] = useState(null);
  const [selectedCan, setSelectedCan] = useState(null);
  const [selectedL89, setSelectedL89] = useState(null);
  const [radioValue, setRadioValue] = useState("all"); // State for radio button
  const [selectedColumns, setSelectedColumns] = useState(headers);
  const [filterHeader, setHeaderFilter] = useState(false);
  const [duplicateData, setDuplicateData] = useState(headers);

  const renderInputLabel = () => {
    switch (selectedColumns.length) {
      case 0:
        return "Select Columns";
      case 1:
      case 2:
        return selectedColumns.map((col) => col.name).join(", ");
      default:
        return `${selectedColumns[0].name} + ${
          selectedColumns.length - 1
        } more`;
    }
  };

  // Handle changes for each Autocomplete
  const handleSoftwareVersionChange = (event, newValue) => {
    setSelectedSoftwareVersion(newValue);
  };

  const handleCanChange = (event, newValue) => {
    setSelectedCan(newValue);
  };

  const handleL89Change = (event, newValue) => {
    setSelectedL89(newValue);
  };

  // Handle change for radio buttons
  const handleRadioChange = (event) => {
    setRadioValue(event.target.value);
  };

  const handleSelectAllChange = (event, selectValue) => {
    let updatedColumns = [];

    if (selectValue) {
      updatedColumns = duplicateData.map((column) => ({
        ...column,
        selected: selectValue,
      }));
    } else {
      updatedColumns = duplicateData.map((column) => ({
        ...column,
        selected: column?.key == "serial" ? true : selectValue,
      }));
    }

    handleHeadersChange(event, updatedColumns); // Call handleChange after updating TableHeadData
  };

  const handleHeadersChange = (e, data) => {
    setHeaderFilter(true);
    const updatedColumns = data.filter((column) => column.selected);
    const updatedSelectedColumns = [...updatedColumns];
    setDuplicateData(data);
    setSelectedColumns(
      updatedSelectedColumns.filter((column) => column.key !== "selectAll")
    );
    setHeaders(updatedSelectedColumns);
  };

  return (
    <DrawerOpen open={open}>
      <Box
        sx={{
          padding: "1rem",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">Filter Preferences</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ flex: 1, marginTop: "1rem" }}>
          {/* Select Boxes */}
          <Divider />
          <FormControl className={styles.radioContainer}>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={radioValue}
              onChange={handleRadioChange}
            >
              <FormControlLabel value="all" control={<Radio />} label="All" />
              <FormControlLabel value="live" control={<Radio />} label="Live" />
              <FormControlLabel
                value="history"
                control={<Radio />}
                label="History"
              />
            </RadioGroup>
          </FormControl>
          <Divider />
          {/* Fields Filter */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "20px",
            }}
          >
            <Autocomplete
              options={softwareVersions}
              value={selectedSoftwareVersion}
              onChange={handleSoftwareVersionChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Software Version"
                  color="grey"
                  size="small"
                  margin="dense"
                  placeholder="Enter Software Version"
                />
              )}
            />
            <Autocomplete
              options={cans}
              value={selectedCan}
              onChange={handleCanChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Can"
                  color="grey"
                  size="small"
                  margin="dense"
                  placeholder="Enter Can"
                />
              )}
            />
            <Autocomplete
              options={l89s}
              value={selectedL89}
              onChange={handleL89Change}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="L89"
                  color="grey"
                  size="small"
                  margin="dense"
                  placeholder="Enter L89"
                />
              )}
            />
          </div>
          <div style={{ textAlign: "end", margin: "10px 0px" }}>
            <Button
              variant="contained"
              className="buttonColor"
              sx={{ marginRight: "10px" }}
            >
              Cancel
            </Button>
            <Button variant="contained" className="buttonColor">
              Submit
            </Button>
          </div>
          <Divider />
          {/* Filter Headers  */}
          <div>
            <Autocomplete
              multiple
              className="headerUpdate"
              id="checkboxes-tags-demo"
              options={duplicateData?.filter((val) => val?.key !== "serial")}
              disableCloseOnSelect
              getOptionLabel={(option) => option.name}
              value={selectedColumns}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    style={{ marginRight: 8 }}
                    checked={option.selected == true ? true : false}
                    onChange={(e) => {
                      if (option.key === "selectAll") {
                        console.log(selected, props);
                        handleSelectAllChange(
                          e,
                          option.selected == true ? false : true
                        );
                      } else {
                        duplicateData.forEach((element, ind) => {
                          if (element.name == option.name) {
                            duplicateData[ind] = {
                              name: option.name,
                              key: option.key,
                              selected: e.target.checked,
                            };
                          }
                        });
                        // Ensure "Select All" is false when any other checkbox is modified
                        duplicateData.forEach((element, ind) => {
                          if (element.key === "selectAll") {
                            duplicateData[ind] = {
                              ...element,
                              selected: false,
                            };
                          }
                        });
                        handleHeadersChange(e, duplicateData);
                      }
                    }}
                  />
                  <ListItemText primary={option.name} />
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Columns"
                  placeholder="Select Columns"
                />
              )}
              renderTags={() => renderInputLabel()}
            />

            {/* Filter tags */}
            <StyledGrid container justifyContent="center" xs={10}>
              {selectedColumns?.map(
                (val) =>
                  val?.key !== "selectAll" &&
                  val?.key !== "serial" && (
                    <Item key={val?.name}>{val?.name}</Item>
                  )
              )}
            </StyledGrid>
          </div>
        </Box>
      </Box>
    </DrawerOpen>
  );
};

export default Filter;
